﻿import {ElementNode, DOMExportOutput, EditorConfig, LexicalNode, NodeKey, SerializedElementNode} from "lexical";

export type SerializedYouTubeNode = SerializedElementNode & {
    type: 'youtube';
    version: 1;
    videoId: string;
};

export class YouTubeNode extends ElementNode {
    videoId: string;

    constructor(videoId: string, key?: NodeKey) {
        super(key);
        this.videoId = videoId;
    }

    static getType(): string {
        return 'youtube';
    }

    static clone(node: YouTubeNode): YouTubeNode {
        return new YouTubeNode(node.videoId, node.__key);
    }

    static importJSON(serializedNode: SerializedYouTubeNode): YouTubeNode {
        const {videoId} = serializedNode;
        return new YouTubeNode(videoId);
    }

    exportJSON(): SerializedYouTubeNode {
        return {
            ...super.exportJSON(),
            type: 'youtube',
            version: 1,
            videoId: this.videoId,
        };
    }

    createDOM(): HTMLElement {
        const container = document.createElement("div");
        container.className = "youtube-node";

        const iframe = document.createElement("iframe");
        iframe.width = "560";
        iframe.height = "315";
        iframe.src = `https://www.youtube.com/embed/${this.videoId}`;
        iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;

        container.appendChild(iframe);
        return container;
    }

    updateDOM(): boolean {
        return false;
    }
}

export function $createYouTubeNode(videoId: string): YouTubeNode {
    return new YouTubeNode(videoId);
}

export function $isYouTubeNode(node?: LexicalNode | null): node is YouTubeNode {
    return node instanceof YouTubeNode;
}
